import React from 'react';
import {Button} from '@mui/material';
import {Delete} from '@mui/icons-material';
import ButtonDialog from 'components/forms/ButtonDialog';
import {useMutate} from 'hooks/useFetchData';
import {RecordType} from 'components/record/RecordContext';
import {useDialogContext} from 'components/dialog/DialogContext';
import {toast} from 'react-toastify';

const ConfirmClearCacheButton = () => {
  const [mutate] = useMutate<{item: RecordType}>('clearAll', 'Cache');
  const {close} = useDialogContext();
  const handleClearCache = () => {
    if (typeof mutate === 'function') {
      mutate()
        .then(() => {
          close();
          toast.success('Cache has been cleared successfully!');
        })
        .catch((error) => {
          if (error.message) {
            toast.error(error.message);
          }
        });
    }
  };
  return (
    <Button variant="contained" onClick={handleClearCache}>
      Clear Cache
    </Button>
  );
};

const ClearCacheButton = () => {
  return (
    <ButtonDialog
      buttonLabel="Clear Cache"
      variant="text"
      maxWidth="sm"
      startIcon={<Delete />}
      dialogTitle="Clear Cache"
      primaryButton={<ConfirmClearCacheButton />}
    >
      Are you sure you want to clear the cache?
    </ButtonDialog>
  );
};

export default ClearCacheButton;
